export default {"src":"/_next/static/media/ic-add-white.2fd0370b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};